import React from 'react';

export default function TermsOfUse({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-2xl p-6 rounded-2xl shadow-xl overflow-auto max-h-[80vh]">
        <h2 className="text-2xl font-bold mb-4">TERMS OF USE – CLINGFILM</h2>
        <p className="text-gray-700 text-sm mb-4">Last Updated: 9 September 2025</p>
        <div className="mb-4 text-gray-700 text-sm leading-relaxed space-y-3">
          <p>Welcome to Clingfilm (“the App”). By downloading, installing, or using the App, you agree to these Terms of Use. Please read them carefully.</p>

          <h3 className="font-semibold mt-4">Use of the App</h3>
          <p>The App is provided for personal, non-commercial use.</p>
          <p>You must be at least 16 years old to use Clingfilm (or the age of digital consent in your country).</p>
          <p>You agree not to misuse the App (e.g. attempt to hack, scrape, or distribute harmful content).</p>

          <h3 className="font-semibold mt-4">Accounts and Content</h3>
          <p>If you create an account, you are responsible for keeping your login details secure.</p>
          <p>Any reviews, ratings, or comments you submit remain your content, but you grant us a licence to display them in the App.</p>
          <p>We may remove content that is illegal, abusive, or infringes on others’ rights.</p>

          <h3 className="font-semibold mt-4">Availability</h3>
          <p>The App is provided “as is” without guarantee of uninterrupted or error-free service.</p>
          <p>Features may change, be limited, or be removed at any time.</p>

          <h3 className="font-semibold mt-4">Limitation of Liability</h3>
          <p>To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the App.</p>

          <h3 className="font-semibold mt-4">Termination</h3>
          <p>We may suspend or terminate access to the App if you breach these terms.</p>
          <p>You may stop using the App at any time.</p>

          <h3 className="font-semibold mt-4">Governing Law</h3>
          <p>These Terms are governed by the laws of France, and disputes will be resolved in French courts.</p>

          <p className="mt-6">Contact: <a href="mailto:angus@veipha.com" className="text-indigo-600 underline">angus@veipha.com</a></p>
        </div>
        <button
          className="brand-button text-lg px-8 py-3 mt-6"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}
